var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDishwasher = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "dishwasher_svg__a",
  d: "M0 19.2h23V0H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(9 10)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M1.4 4.7V2.5c0-1.1.9-2 2-2h16.3c1.1 0 2 .9 2 2v2.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#58595B",
  d: "M15.7 2.2H7.3c-.9 0-1.7.3-1.7.8v.1h11.8V3c0-.5-.8-.8-1.7-.8"
}), /*#__PURE__*/React.createElement("mask", {
  id: "dishwasher_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dishwasher_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M1.4 15.5h20.3V4.8H1.4zM4.4 7l6.1 6M18.6 7l-6.1 6",
  mask: "url(#dishwasher_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#58595B",
  d: "M22.5 16.5c0 1.2-1 2.2-2.2 2.2H2.7c-1.2 0-2.2-1-2.2-2.2v-1.1h22z",
  mask: "url(#dishwasher_svg__b)"
}))));
export default SvgDishwasher;